@if (newTask) {
  <div class="trigger-buttons-container">
    <projects-task-check-button
      [selected]="scheduleControl.get('scheduleType').value !== 'trigger'"
      (buttonClick)="onNoTrigger()"
      width="100%"
      class="mb-10"
    >
      No trigger
    </projects-task-check-button>
    <projects-task-check-button
      [selected]="scheduleControl.get('scheduleType').value === 'trigger'"
      (buttonClick)="onAddTrigger()"
      width="100%"
      class="mb-10"
    >
      Yes, add trigger
    </projects-task-check-button>
  </div>
}

@if (scheduleControl.get('scheduleType').value === 'trigger') {
  <!-- -----------------------TRIGGER RUNS ROW---------------------- -->
  <div class="row">
    <span>Trigger runs</span>
    <!-- -----FOREVER BUTTON----- -->
    <button
      class="row-button forever-button"
      [class.selected-row-button]="form.get('triggerEndsType').value === 'forever'"
      [class.task-item-variable-bg]="!newTask"
      (click)="onTriggerEndsTypeChange('forever')"
    >
      Unlimited
    </button>

    <input
      type="number"
      class="trigger-input"
      [formControl]="$any(form.get('triggerEndsTaskCountValue'))"
      [class.selected-trigger-input]="form.get('triggerEndsType').value === 'tasks'"
      (focus)="onTriggerEndsTypeChange('tasks')"
      (blur)="onInputBlur()"
    />
    <span>times</span>
  </div>

  <!-- -----------------------TRIGGERED TASK EXPIRATION ROW---------------------- -->
  <div class="row">
    <span>Triggered tasks expire after</span>
    <button
      (click)="onTriggeredTaskExpiration('never')"
      class="row-button expiration-button"
      [class.task-item-variable-bg]="!newTask"
      [class.selected-row-button]="form.get('triggeredTaskExpiration').value === 'never'"
    >
      Never
    </button>
    <button
      class="row-button expiration-menu-button"
      [matMenuTriggerFor]="expirationMenu"
      [class.task-item-variable-bg]="!newTask"
      [class.selected-row-button]="form.get('triggeredTaskExpiration').value !== 'never'"
    >
      <img src="assets/img/icons/clock-brown.svg" />
      {{ triggeredTaskExpirationDisplay }}
    </button>
    <mat-menu #expirationMenu="matMenu" class="oph-select-menu">
      @for (option of triggeredTaskExpirationOptions; track option) {
        <button class="oph-select-menu-item" (click)="onTriggeredTaskExpiration(option)">{{ option }}</button>
      }
    </mat-menu>
  </div>

  <!-- -----------------------CHECKBOX ROW---------------------- -->
  <div class="row">
    <oph-checkbox
      [control]="$any(this.form.get('triggerDisplayAlert'))"
      textOrientation="right"
      text="Display alert"
      [width]="25"
      [textStyle]="{
        color: 'var(--Ophanim-Final-Off-black, #4A443D)',
        'font-family': 'Asap',
        'font-size': '15px',
        'font-style': 'normal',
        'font-weight': '400'
      }"
      color="green"
    ></oph-checkbox>
  </div>

  <div class="trigger-container">
    @for (triggerFormGroup of triggersFormArray.controls; track $index) {
      <div class="w-100">
        <task-trigger-selection
          [triggerFormGroup]="$any(triggerFormGroup)"
          [hideXButton]="!triggerFormGroup.get('trackerId').value"
          [error]="validationErrors?.isOneTriggerComplete"
          (removeItem)="onClearTrigger($index)"
          (newClick)="newTrackerClick.emit()"
        />
      </div>
    }
  </div>
} @else {
  <div class="info-container">
    <div class="left-container">
      <div class="icon-container">
        <img src="assets/img/icons/bolt-2.svg" />
      </div>
    </div>
    <div class="right-container">
      <p>
        Triggers control when a task becomes active. For instance, you may have a task that only shows up when a tracker
        reaches a particular value.
      </p>
    </div>
  </div>
}
